const translations = {
    'battle.report.title': 'Raport bitwy',
    'battle.report.missing': 'Nie znaleziono raportu bitwy.',
    'battle.report.summary': 'Podsumowanie',
    'battle.report.tile': 'Pole: %s',
    'battle.report.result': 'Wynik: %s',
    'battle.report.losses': 'Straty: %d vs %d',
    'battle.report.rounds': 'Rundy',
    'battle.report.roundsNone': 'Brak zapisanych rund.',
    'battle.report.roundLabel': 'Runda %d',
    'battle.report.roundDetail': 'Zabici %d/%d • Pozostali %d/%d',
    'battle.result.attacker': 'Zwycięstwo',
    'battle.result.defender': 'Porażka',
    'battle.result.draw': 'Remis',
    'unit.militia': 'Milicja',
    'enemy.bandits': 'Bandyci',
    'enemy.goblins': 'Gobliny',
    'enemy.orcs': 'Orki',
};

export default translations;
